import React from 'react';
import DentalServicePage from './DentalServicePage';

const PediatricDentistry = () => {
    // Defined content for Pediatric Dentistry
    const serviceName = 'Pediatric Dentistry';
    const serviceTagline = 'Gentle, child-friendly dental care that builds a lifetime of healthy smiles';

    const whatIsContent = [
        'Pediatric dentistry is a specialized branch of dentistry focused on the oral health of children from infancy through adolescence. At Wisdom Dental Clinic, our pediatric dental services are designed to provide comprehensive, gentle care in a child-friendly environment that helps young patients develop positive associations with dental visits and establish good oral hygiene habits early in life.',
        "Our approach to pediatric dentistry combines preventive care, early intervention, education, and age-appropriate treatments. We understand that children's dental needs differ from adults, requiring specific techniques and a nurturing touch. Our team is trained to address the unique dental development stages of children while making each visit fun, educational, and stress-free for both children and parents.",
    ];

    const whenRequiredContent = {
        paragraphs: ["Regular dental care should begin early in a child's life to establish a foundation for lifelong oral health."],
        listIntro: 'Your child should visit a pediatric dentist:',
        list: [
            'For their first dental visit by age 1 or when the first tooth appears',
            'Every six months for regular checkups and cleanings',
            'When baby teeth begin to loosen and permanent teeth emerge',
            'If they experience tooth pain or sensitivity',
            'After dental trauma or injury',
            'If you notice discoloration, spots, or cavities on their teeth',
            'For preventive treatments like sealants and fluoride',
            'To monitor growth and development of teeth and jaws',
        ],
        closing:
            "Early and regular dental visits help prevent problems, identify issues when they're easier to treat, and help your child develop a positive relationship with dental care that can last a lifetime.",
    };

    const howDoneContent = {
        paragraphs: [
            "At Wisdom Dental Clinic, we've created a child-centered approach to pediatric dentistry that focuses on making dental visits positive and educational while providing excellent clinical care.",
        ],
        listIntro: 'Our pediatric dental services include:',
        list: [
            'Child-friendly office design with playful decor and activities',
            'Tell-show-do approach to introduce dental procedures',
            'Gentle examination techniques specifically for children',
            'Digital X-rays with minimal radiation exposure',
            'Preventive treatments including sealants and fluoride',
            'Age-appropriate oral hygiene education',
            'Behavior guidance for anxious or special needs children',
            'Parent education on nutrition and home care techniques',
        ],
        closing:
            "Our pediatric dental specialists have additional training beyond dental school focused specifically on children's developing teeth, child psychology, and creating positive dental experiences. We partner with parents to establish healthy habits that will benefit your child throughout their life.",
    };

    const benefitsContent = [
        {
            title: 'Preventive Focus',
            description: 'Early care prevents cavities and establishes good dental habits',
        },
        {
            title: 'Specialized Knowledge',
            description: "Expertise in children's dental development and unique needs",
        },
        {
            title: 'Positive Experience',
            description: 'Child-friendly environment reduces anxiety about dental visits',
        },
        {
            title: 'Growth Monitoring',
            description: 'Early identification of orthodontic needs or development issues',
        },
        {
            title: 'Parent Education',
            description: 'Guidance on nutrition, habits, and home care techniques',
        },
        {
            title: 'Foundation for Life',
            description: 'Establishing positive dental experiences that encourage lifelong care',
        },
    ];

    const procedureSteps = [
        {
            title: 'Welcoming Introduction',
            description: 'Child-friendly introduction to the dental environment, equipment, and team members to build comfort and trust',
        },
        {
            title: 'Gentle Examination',
            description:
                'Thorough but gentle assessment of teeth, gums, bite, and oral development using child-appropriate language and techniques',
        },
        {
            title: 'Cleaning and Polishing',
            description:
                'Age-appropriate cleaning using gentle tools, flavored polishes, and positive reinforcement throughout the process',
        },
        {
            title: 'Preventive Applications',
            description: 'Application of fluoride treatments and/or dental sealants as needed to prevent cavities and strengthen enamel',
        },
        {
            title: 'Interactive Education',
            description: 'Fun, age-appropriate demonstrations of brushing and flossing techniques using models, videos, or games',
        },
        {
            title: 'Parent Consultation',
            description:
                'Discussion of findings, developmental milestones, nutritional guidance, and personalized recommendations for home care',
        },
    ];

    const seoData = {
        title: 'Pediatric Dentistry in Sector 23, Palam Vihar, Gurgaon',
        description:
            'Looking for the Best Pediatric Dentistry Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable Pediatric Dentist. Call now!',
        keywords:
            "Pediatric Dentistry in Gurgaon,Besediatric Dentist doctors Near Me in Gurgaon,Pediatric Dental clinic in Gurgaon,DChildren's Dentistry Near Me,Pediatric Dentist Sector 23 gurgaon, Pediatric Dentist palam vihar gurgaon",
        canonical: 'https://wisdomdentalclinics.in/pediatric-dentistry',
        ogTitle: 'Pediatric Dentistry in Sector 23, Palam Vihar, Gurgaon',
        ogDescription:
            'Looking for the Best Pediatric Dentistry Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable Pediatric Dentist. Call now!',
        twitterTitle: 'Pediatric Dentistry in Sector 23, Palam Vihar, Gurgaon',
        twitterDescription:
            'Looking for the Best Pediatric Dentistry Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable Pediatric Dentist. Call now!',
        h1Text: 'Pediatric Dentistry in Sector 23 Palam Vihar Gurgaon',
    };

    return (
        <DentalServicePage
            serviceName={serviceName}
            serviceTagline={serviceTagline}
            whatIsContent={whatIsContent}
            whenRequiredContent={whenRequiredContent}
            howDoneContent={howDoneContent}
            benefitsContent={benefitsContent}
            procedureSteps={procedureSteps}
            seoData={seoData}
        />
    );
};

export default PediatricDentistry;
